/* global $ */
import React, { useEffect, useState } from "react";
// import { refer_earn_dashboard, fetchUserData, MilestoneClaim } from "../../services/api";
import { makeAPI } from "../../services/api";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import { getViteImage } from "../../utils/utils";
// import { toast } from "react-toastify";
// import { useGlobalState } from "../../contexts/user";

export default function ReferEarnDashboard() {
    // const {user} = useGlobalState();
    // let userData = JSON.parser(localStorage.getItem('user'));
    const userData = JSON.parse(localStorage.getItem('user'));
    const isLoggedIn = Boolean(userData?.user_id);

    // let userData = JSON.parse(localStorage.getItem('user')) || "";
    const [dashboard_data, setdashboard_data] = useState({});
    const [top3_leaderboard, settop3_leaderboard] = useState({});
    const [referral_leaderboard, setreferral_leaderboard] = useState([]);

    useEffect(() => {
    document.title = "Refer & Earn - CGES.CLUB";

        if (isLoggedIn) {
            initializeDashboard();
        }
    }, [isLoggedIn]);
    const initializeDashboard = async () => {
        // alert("initializeDashboard")
        try {
            enablePreloader();
            await referal_dashboard();
        } catch (error) {
            console.log("Error initializing dashboard:", error);
        }
    };
    async function referal_dashboard(user_id = userData?.user_id, month) {
        // alert("referal dashboard")
        if (!user_id) return;
        try {
            let data = await makeAPI('/api/refer_earn_dashboard', 'post', false, { user_id, month });
            if (!data.response.data.month_key) {
                setdashboard_data(data.response.data);
                setreferral_leaderboard(data.response.data.obj_data);
            }
            settop3_leaderboard(data.response.data.leaderboard_data);
        } catch (error) {
            console.log("Error fetching referral dashboard data:", error);
        }
    }

    function openLoginModal() {
        if (window.UIkit && typeof window.UIkit.modal === "function") {
            window.UIkit.modal("#modal-login", { container: false }).show();
            return;
        }
        window.location.href = "/";
    }
    useEffect(() => {
        // alert("useeffect 23")
        if (dashboard_data && Object.keys(dashboard_data).length > 0) {
            // alert("update")
            try {

                if ($.fn.DataTable.isDataTable('#referal-leaderboard-data')) {
                    $('#referal-leaderboard-data').DataTable().destroy();
                }
                referal_leaderboard_data();
                dropdown_create();
                bar_progress();
            } catch (error) {
                console.error("Error in DOM operations:", error);
            }
        }
        else {
            // alert("no update")
        }
    }, [dashboard_data])

    let data_set = referral_leaderboard || [];
    // console.log("referaaal leaderboard data",data_set);

    async function referal_leaderboard_data() {
        // alert(1)
        let referral_leaderboard_stat = true;
        try {
            $('#referal-leaderboard-data').DataTable({
                "stateSave": false,
                "responsive": {
                    details: {
                        type: 'column',
                        target: 'tr'
                    }
                },
                "bInfo": false,
                "bDestroy": true,
                "bPaginate": false,
                "ordering": false,
                "serverSide": false,
                "bAutoWidth": false,
                "searching": false,
                "lengthMenu": [10, 20, 30, 50],
                "lengthChange": false,
                "orderable": false,
                "paging": true,
                data: data_set,
                "columns": [
                    {
                        data: null, title: "S.NO",
                        render: function (data, type, row, meta) {
                            return meta.row + 1;
                        }
                    },
                    {
                        data: 'name', title: "Name"
                    },
                    {
                        data: 'referal_stat', title: "Activity",
                        render: function (referal_stat) {
                            if (referal_stat === 1) {
                                return "Signup"
                            }
                            else if (referal_stat === 2) {
                                return "First Play"
                            }
                            else if (referal_stat === 3) {
                                return "First Win"
                            }
                            else {
                                return "Signup"
                            }
                        }
                    },
                    {
                        data: 'referal_stat', title: "Signup",
                        render: function (referal_stat) {
                            if (referal_stat >= 1) {
                                return "✅"
                            }
                            else {
                                return "❌"
                            }
                        }
                    },
                    {
                        data: 'referal_stat', title: "First play",
                        render: function (referal_stat) {
                            if (referal_stat >= 2) {
                                return "✅"
                            }
                            else {
                                return "❌"
                            }
                        }
                    },
                    {
                        data: 'referal_stat', title: "First Win",
                        render: function (referal_stat) {
                            if (referal_stat >= 3) {
                                return "✅"
                            }
                            else {
                                return "❌"
                            }
                        }
                    },

                    {
                        data: 'referal_stat', title: "Status",
                        render: function (referal_stat) {
                            var data = "Completed";
                            var color = "";
                            if (referal_stat === 3) {
                                data = "Completed";
                                color = "#22ff22ff";
                            }
                            else if (referal_stat === 2 || referal_stat === 1) {
                                data = "Pending";
                                color = "#FF810E";
                            }
                            else {
                                data = "Pending";
                                color = "#FF810E"
                            }
                            return `<span style="color:${color}">${data}</span>`;
                        }
                    }
                ],
                "columnDefs": [
                    {
                        className: "dt-head-left dt-body-left",
                        targets: '_all'
                    },
                    { 
                        width: '8%', 
                        targets: 0,
                        responsivePriority: 1 // Always show S.NO
                    },
                    { 
                        width: '20%', 
                        targets: 1,
                        responsivePriority: 2 // Always show Name
                    },
                    { 
                        width: '15%', 
                        targets: 2,
                        responsivePriority: 3 // Show Activity next
                    },
                    { 
                        width: '12%', 
                        targets: 3,
                        responsivePriority: 6 // Hide Signup first
                    },
                    { 
                        width: '15%', 
                        targets: 4,
                        responsivePriority: 5 // Hide First play later
                    },
                    { 
                        width: '15%', 
                        targets: 5,
                        responsivePriority: 4 // Hide First Win later
                    },
                    { 
                        width: '15%', 
                        targets: 6,
                        responsivePriority: 2 // Always show Status
                    },
                ],
            });
        } catch (error) {
            console.log("Error in referal_leaderboard_data:", error);
        }
    }

    function copy_btn() {
        var copy_text = document.getElementById("invite-code");
        var text = copy_text.textContent.split('#');
        var link = "https://cges.club/invite/" + userData?.user_id;
        navigator.clipboard.writeText(link).then((e) => {
            copiedBtn();
        }).catch((err) => {
            console.log("error", err);
        });

    }

    function copiedBtn() {
        const copy_btn = document.querySelector('.fa-copy');
        if (!copy_btn) return;
        let tooltip_text = document.createElement('span');
        tooltip_text.innerText = 'Copied!';
        tooltip_text.style.position = 'absolute';
        tooltip_text.style.background = '#333';
        tooltip_text.style.color = '#fff';
        tooltip_text.style.padding = '2px 8px';
        tooltip_text.style.borderRadius = '4px';
        tooltip_text.style.fontSize = '12px';
        tooltip_text.style.top = '-28px';
        tooltip_text.style.right = '0';
        tooltip_text.style.zIndex = '1000';
        tooltip_text.className = 'copied-tooltip_text';

        copy_btn.parentElement.style.position = 'relative';
        copy_btn.parentElement.appendChild(tooltip_text);

        setTimeout(() => {
            tooltip_text.remove();
        }, 2000);
    }

    function dropdown_create() {
        // alert(" dropdown 2");

        if (!dashboard_data) {
            console("hide dropdown 2");
            return;
        }

        let select_val = document.getElementById('referal_month_dropdown');
        if (!select_val) {
            return;
        }
        let current_val = select_val.value;
        select_val.innerHTML = '';

        let current_date = new Date(dashboard_data.date);
        let month = current_date.getMonth();
        let year = current_date.getFullYear();

        current_date.setDate(1);
        let month_0 = new Date(current_date);
        month_0.setMonth(month);

        let month_1 = new Date(current_date);
        month_1.setMonth(month - 1);

        let month_2 = new Date(current_date);
        month_2.setMonth(month - 2);

        let arr_of_month = [
            { month: month_0.getMonth(), year: month_0.getFullYear() },
            { month: month_1.getMonth(), year: month_1.getFullYear() },
            { month: month_2.getMonth(), year: month_2.getFullYear() }
        ];

        arr_of_month.forEach(item => {
            const option = document.createElement('option');
            option.value = item.month;
            option.textContent = new Date(0, item.month).toLocaleString('default', { month: 'long' }) + " " + item.year;
            // option.style.fontSize = "10px";
            if (current_val && current_val === item.month) {
                option.selected = true;
            }
            select_val.appendChild(option);
        });
    }

    const enablePreloader = () => {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "1";
            preloader.style.visibility = "visible";
            setTimeout(() => {
                preloader.style.opacity = "0";
                preloader.style.visibility = "hidden";
            }, 1000);
        }
    };
    function disablePreloader() {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "0";
            setTimeout(() => {
                preloader.style.visibility = "hidden";
            }, 1000);
        }
    }

    async function mile_stone_claim() {
        // alert("Milestone reward!");
        let milestone_stat = await makeAPI('/api/refer_earn_dashboard/milestone', 'post', false, { user_id: userData.user_id, milestone: false });
        let milestonearray = milestone_stat?.milestone || [];
        // alert("successfully completed",milestonearray)
        if (milestonearray.length > 0 && milestone_stat.is_claimed === true) {
            alert("Milestone reward claimed successfully!");
            // toast.success("Milestone reward claimed successfully!");
            let update_localstorage_user = await makeAPI('/api/get_user_data', 'post', true, {});
            if (update_localstorage_user.status === 'S') {
                // alert("Coin balance updated successfully!");
                document.getElementById('progress-claim').disabled = true;
                let current_bal = update_localstorage_user?.data?.coin_balance || 0;
                localStorage.setItem('user', JSON.stringify(update_localstorage_user));
                coin_effect(Number(current_bal), Number(userData.coin_balance));
            }
        }
        else {
            document.getElementById('progress-claim').disabled = true;
            alert("Milestone not reached or already claimed");
            // toast.warning("Milestone not reached or already claimed");
            console.log("Milestone not reached or already claimed");
        }
        // page reload 
        initializeDashboard();
    }

    function coin_effect(currentBalance, previousBalance) {
        // console.log("enter into function", currentBalance + "" + previousBalance);
        if (currentBalance != null && previousBalance != null) {
            if (currentBalance !== previousBalance) {
                $(".coin-balance").prop("number", previousBalance).animateNumber(
                    { number: currentBalance },
                    500
                );
            }
        }
    }

    async function bar_progress() {
        // alert("3")
        let progress_count = dashboard_data.total_count || 0;
        let MILESTONE_SIZE = 5;
        let precentage = (progress_count % MILESTONE_SIZE) * 20;
        let progress_bar = document.getElementById('progress-bar');
        let claim_btn = document.getElementById('progress-claim');
        let currentMilestone = Math.floor(progress_count / 5) * 5;
        let milestone_stats;
        try {
            let user = await makeAPI('/api/get_user_data', 'post', true, {});
            let milestone_info = await makeAPI('/api/refer_earn_dashboard/milestone', 'post', false, { user_id: user.data.user_id, milestone: undefined });
            milestone_stats = milestone_info.is_claimed;
        } catch (error) {
            console.log("error", error);
        }
        // console.log("milestone_stats",milestone_stats);

        let already_claim = milestone_stats === true ? true : false;

        let btn_stat = progress_count % MILESTONE_SIZE === 0 && progress_count !== 0 && !already_claim;

        if (progress_bar) {
            // alert(precentage);
            if (!precentage === 0) {
                progress_bar.style.width = btn_stat ? "100%" : precentage + "%";
            }
            progress_bar.style.width = btn_stat ? "100%" : 2 + "%";
        }
        if (claim_btn) {
            claim_btn.disabled = !btn_stat;
        }
    }

    // if(user === "" ||  user === undefined || user?.user_id === undefined) {
    //     window.location.href = '/';
    //     return null; // Prevent rendering if user data is not available
    // }


    if (!isLoggedIn) {
        return (
            <>
                <div className="container refer-brochure-wrap pd-top-120 pd-bottom-90">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="refer-brochure-hero text-center">
                                <h2 className="title move-line-3d mb-2">Refer & Earn</h2>
                                <p className="refer-brochure-subtitle">
                                    Invite friends, help them start playing, and unlock rewards as their activity grows.
                                </p>
                                <button className="btn btn-base refer-brochure-cta" onClick={openLoginModal}>
                                    Login To View Referral Analytics
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 justify-content-center mt-2">
                        <div className="col-lg-5 col-md-10">
                            <div className="refer-brochure-card">
                                <h4>Why Refer</h4>
                                <ul className="refer-brochure-list">
                                    <li>Share your personal invite code/link in one click.</li>
                                    <li>Track signup, first play, and first win milestones.</li>
                                    <li>Earn milestone rewards for every 5 successful referrals.</li>
                                </ul>
                                <div className="refer-brochure-highlight">
                                    
                                    Every 5 referrals = <img src={getViteImage("icons/coin.avif")} alt="coin" width={16} />150 reward coins
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-10">
                            <div className="refer-brochure-card">
                                <h4>After Login You Can</h4>
                                <ul className="refer-brochure-list">
                                    <li>See total, pending, and completed referral stats.</li>
                                    <li>View top leaderboard and monthly performance.</li>
                                    <li>Claim eligible rewards directly from dashboard.</li>
                                </ul>
                                <div className="refer-brochure-ranks">
                                    <span className="rank-chip">1st:&nbsp;<img src={getViteImage("icons/coin.avif")} width={15}/> 5000</span>
                                    <span className="rank-chip">2nd:&nbsp;<img src={getViteImage("icons/coin.avif")} width={15}/> 3000</span>
                                    <span className="rank-chip">3rd:&nbsp;<img src={getViteImage("icons/coin.avif")} width={15}/> 1000</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center mt-2">
                        <div className="col-lg-10">
                            <div className="refer-brochure-steps">
                                <h5 className="text-center mb-3">Simple Flow</h5>
                                <div className="refer-brochure-step-grid">
                                    <div className="refer-step-chip">1. Login</div>
                                    <div className="refer-step-chip">2. Share invite link</div>
                                    <div className="refer-step-chip">3. Friends complete activity</div>
                                    <div className="refer-step-chip">4. Track and claim rewards</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>{`
                    .refer-brochure-wrap {
                        min-height: 72vh;
                    }
                    .refer-brochure-hero {
                        background: radial-gradient(circle at top right, rgba(255, 129, 14, 0.26), transparent 42%), #121212;
                        border: 1px solid #3a3a3a;
                        border-radius: 14px;
                        padding: 26px 20px;
                    }
                    .refer-brochure-subtitle {
                        max-width: 720px;
                        margin: 0 auto 14px;
                        color: #e4e4e4;
                    }
                    .refer-brochure-cta {
                        border: 1px solid #ff810e;
                        background: #161616;
                        color: #fff;
                        min-width: 260px;
                    }
                    .refer-brochure-card {
                        height: 100%;
                        background: linear-gradient(180deg, #171717 0%, #101010 100%);
                        border: 1px solid #333;
                        border-radius: 12px;
                        padding: 18px;
                        color: #e4e4e4;
                    }
                    .refer-brochure-card h4 {
                        color: var(--main-color-one);
                        margin-bottom: 10px;
                    }
                    .refer-brochure-list {
                        margin: 0;
                        padding-left: 18px;
                    }
                    .refer-brochure-list li {
                        margin-bottom: 9px;
                    }
                    .refer-brochure-highlight {
                        display: inline-flex;
                        align-items: center;
                        gap: 6px;
                        margin-top: 10px;
                        background: #0f0f0f;
                        border: 1px solid #2f2f2f;
                        border-radius: 999px;
                        padding: 8px 14px;
                        font-weight: 600;
                    }
                    .refer-brochure-ranks {
                        margin-top: 10px;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .rank-chip {
                        border: 1px dashed #ff810e;
                        background: #181818;
                        color: #f3f3f3;
                        padding: 6px 10px;
                        border-radius: 999px;
                        font-size: 13px;
                    }
                    .refer-brochure-steps {
                        margin-top: 12px;
                        padding: 20px;
                        border: 1px solid #333;
                        border-radius: 12px;
                        background: #121212;
                    }
                    .refer-brochure-step-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 10px;
                    }
                    .refer-step-chip {
                        border: 1px dashed #ff810e;
                        background: #181818;
                        color: #f3f3f3;
                        padding: 10px 12px;
                        border-radius: 8px;
                        text-align: center;
                        font-size: 14px;
                    }
                    @media (max-width: 767px) {
                        .refer-brochure-wrap {
                            min-height: auto;
                        }
                        .refer-brochure-hero {
                            padding: 20px 14px;
                        }
                        .refer-brochure-step-grid {
                            grid-template-columns: 1fr;
                        }
                        .refer-brochure-cta {
                            width: 100%;
                            min-width: 0;
                        }
                    }
                `}</style>
            </>
        );
    }

    return (
        <>
            <div className="container">
                <div className="row justify-content-center pd-top-120">
                    <div className="col-lg-6">
                        <div className="section-title text-center">
                            <h2 className="title move-line-3d">Referral Dashboard</h2>
                            {/* <img className="mt-3" src="./assets/img/icon/shalep-1.avif" alt="img" /> */}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-sm-12">
                        <div className="media product-cart-inner" style={{ borderBottom: "none", paddingBottom: "0px", marginBottom: "0px" }}>
                            <div className="media-body align-self-center mt-4">
                                <div className="color-plate d-block" >
                                    <div className="col-lg-4 col-md-6 fade-slide bottom" data-delay="0.2"
                                        style={{ width: "100%" }}>
                                        <div className="single-platform-inner style-2" style={{ backgroundColor: "#161616", borderRadius: "5px" }}>
                                            {/* <img className="bg-image" src="assets/img/bg/5.avif" alt="img" /> */}
                                            <div className="details-inner">
                                                <div className="">
                                                    <div className="icon" style={{ marginBottom: '0px' }}>
                                                        <h4 className="text-center" style={{ color: `var(--main-color-one)`, marginBottom: "1px" }}>Referral Milestone </h4>
                                                        <p className="text-center" style={{ fontWeight: 'unset' }}>Note : Every 5 Referral you get a reward of <img src={getViteImage("icons/coin.avif")}
                                                            style={{ top: "-1px", width: "16px", height: "14px", marginBottom: "0px", position: "relative" }} />150 </p>
                                                    </div>
                                                </div>
                                                <div className="progress" style={{ height: "8px", marginBottom: "15px" }}>
                                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="10" aria-valuemin="0"
                                                        aria-valuemax="100" style={{ backgroundColor: "#ff810e" }} id="progress-bar"
                                                    ></div>
                                                </div>

                                                <div>
                                                    <a className=" text-end cat " >
                                                        Total Referral
                                                    </a>
                                                    <div className="amount-area d-flex justify-content-between mt-1" id="invite-code">
                                                        <span className="title" style={{ color: "var(--main-color-one)" }}>{dashboard_data.total_count}</span>
                                                        <button className="btn btn base" id="progress-claim"
                                                            style={{
                                                                padding: "1px",
                                                                height: "40px",
                                                                width: "100px",
                                                                verticalAlign: "middle",
                                                                lineHeight: "27px",
                                                                color: "#fff",
                                                                border: "1px solid #ff810e",
                                                                backgroundColor: "#151f29",
                                                            }}
                                                            onClick={mile_stone_claim}
                                                        >Claim</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <div className="media product-cart-inner" style={{ borderBottom: "none", paddingBottom: "0px", marginBottom: "0px" }}>
                            <div className="media-body align-self-center mt-4">
                                <div className="color-plate d-block" >
                                    <div className="col-lg-4 col-md-6 fade-slide bottom" data-delay="0.2"
                                        style={{ width: "100%" }}>
                                        <div className="single-platform-inner style-2" style={{ backgroundColor: "#161616", borderRadius: "5px" }}>
                                            {/* <img className="bg-image" src="assets/img/bg/5.avif" alt="img" /> */}
                                            <div className="details-inner">
                                                <div className="">
                                                    <div className="icon" style={{ marginBottom: '0px' }}>
                                                        <h4 className="text-center" style={{ marginBottom: '0px', color: `var(--main-color-one)` }}>Refer & Earn </h4>
                                                        <p className="text-center" style={{ fontWeight: 'unset' }}>Invite Your Friends & Get Rewards </p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div>
                                                    <a className=" text-end cat" >
                                                        Your Invite Code
                                                    </a>
                                                    <div className="amount-area d-flex justify-content-between mt-2 " id="invite-code">
                                                        <span className="title">#{userData?.user_id}</span>
                                                        <div>
                                                            <a
                                                                href={`https://api.whatsapp.com/send/?text=${encodeURIComponent(`🎮 Join CGES.club using my invite link and earn bonus coins.🎉
                                                                Play tournaments, improve your rank, and redeem exciting rewards. 👉 https://cges.club/invite/${userData?.user_id}`)}`}
                                                                target='_blank'
                                                                rel='noreferrer'>
                                                                <i className="fa-solid fa-share-nodes fa-xl" style={{ color: "#ff810e" }}></i>
                                                            </a>
                                                            <button className="color-base title" style={{
                                                                background: "none", border: "none"
                                                            }}>&nbsp;&nbsp;<i className="fa-solid fa-copy fa-lg" style={{ color: "#ff810e" }} onClick={() => copy_btn()}></i></button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-lg-6 col-sm-12  mb-4 mb-lg-0">
                        <div className="widget widget-trending-match">
                            <h3 className="title fs-5">Your Referral Info</h3>
                            <ul>
                                <li>
                                    <div className="thumb">
                                        <i className="fa-solid fa-users fa-2x"></i>
                                    </div>
                                    <div className="details">
                                        <h4>No.of Referral</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold", color: "var(--main-color-one)" }}>{dashboard_data.total_count} </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="thumb">
                                        <i className="fa-solid fa-user-clock fa-2x"></i>
                                    </div>
                                    <div className="details">
                                        <h4>Pending</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold", color: "var(--main-color-one)" }}> {dashboard_data.pending}</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="thumb">
                                        <i className="fa-solid fa-user-check fa-2x"></i>
                                    </div>
                                    <div className="details">
                                        <h4>Completed</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold", color: "var(--main-color-one)" }}> {dashboard_data.completed || 0}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-sm-12 ">
                        <div className="widget widget-trending-match">
                            <h3 className="title fs-5 text-center"> Top 3 Referral Leaderboard &nbsp;
                                <div className="filter-inner-btn rounded" style={{ padding: "4px", border: "1px solid #808080", position: "relative", left: "6%" }}>
                                    <select className="data-shop-sortby text-center" id="referal_month_dropdown" onChange={(e) => {
                                        referal_dashboard(userData.user_id, e.target.value)
                                    }}>
                                        <option value={''}>Select Month</option>
                                    </select>
                                </div>
                            </h3>
                            <ul>
                                <li>
                                    <div className="thumb">
                                        <img src={getViteImage("icons/rank_1.avif")} alt="img" />
                                    </div>
                                    <div className="details">
                                        <h4 className="">{top3_leaderboard[0]?.name || '1st Position'}</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold" }}>{top3_leaderboard[0]?.count || ''}</span>
                                        <span className="right-icon"><span style={{ position: "relative", top: "-1px" }}><img className="" src={getViteImage("icons/coin.avif")} alt="img" width={16} /></span>5000</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="thumb">
                                        <img src={getViteImage("icons/rank_2.avif")} alt="img" />
                                    </div>
                                    <div className="details">
                                        <h4>{top3_leaderboard[1]?.name || '2nd Position'}</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold" }}> {top3_leaderboard[1]?.count || ''}</span>
                                        <span className="right-icon"><span style={{ position: "relative", top: "-1px" }}><img className="" src={getViteImage("icons/coin.avif")} alt="img" width={16} /></span>3000</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="thumb">
                                        <img src={getViteImage("icons/rank_3.avif")} alt="img" />
                                    </div>
                                    <div className="details">
                                        <h4>{top3_leaderboard[2]?.name || '3rd Position'}</h4>
                                        <span className="color-base" style={{ fontSize: "20px", fontWeight: "bold" }}> {top3_leaderboard[2]?.count || ''}</span>
                                        <span className="right-icon"><span style={{ position: "relative", top: "-1px" }}><img className="" src={getViteImage("icons/coin.avif")} alt="img" width={16} /></span>1000</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="row justify-content-center">
                    <h5 className="text-center m-0" style={{ textDecoration: "underline",fontSize:"20px" }}>Your Referral Stats </h5>
                    <div className='col-lg-6 col-sm-12 table-responsive-wrapper mt-2'>
                        <div className="table-responsive">
                            <table id="referal-leaderboard-data" className="table table-striped-white table-dark w-100 ">
                                <thead>
                                    <tr></tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {
                    `
                       

                                        .widget-trending-match ul li .thumb img {
                                            max-width: 40px;
                                        }
                                        #referal-leaderboard-data thead th {
                                            border-bottom: 1px solid #fff !important;
                                            border-top: 0 !important;
                                            border-left: 0 !important;
                                            border-right: 0 !important;
                                        }
                                        .widget-trending-match {
                                            border: 2px solid #303030;
                                            box-sizing: border-box;
                                        }
                                        trending-match, .widget_author .details h6 {
                                             margin-bottom: 30px;
                                        }
                                        .widget-trending-match .title {
                                            background-color: #161616;
                                            border-bottom: 2px solid #303030;
                                            font-size: 24px;
                                            padding: 18px 20px;
                                            text-transform: uppercase;
                                            margin-bottom: 0;
                                        }
                                        .widget-trending-match ul {
                                            margin: 0;
                                            padding: 0;
                                            line-height: 1;
                                        }
                                        .widget-trending-match ul li {
                                            list-style: none;
                                            display: flex;
                                            -ms-flex-align: center;
                                            align-items: center;
                                            position: relative;
                                            border-bottom: 1px solid #303030;
                                        }
                                        .widget-trending-match ul li .thumb {
                                            background-color: #161616;
                                            border-right: 2px solid #303030;
                                            height: 80px;
                                            width: 80px;
                                            display: flex;
                                            -ms-flex-align: center;
                                            align-items: center;
                                            -webkit-box-pack: center;
                                            -ms-flex-pack: center;
                                            justify-content: center;
                                            margin-right: 20px;
                                        }
                                        .filter-inner-btn {
                                            border: 1px dotted #181f27;
                                            display: inline-block;
                                            padding: 6px 10px 6px 12px;
                                            border-radius: 6px;
                                        }
                                        .rounded {
                                            border-radius: 0.25rem !important;
                                        }
                                        .filter-inner-btn select {
                                            background-color: black;
                                            color: #fff;
                                            border: 0;
                                        }
                                            .text-end {
                                            text-align: right !important;
                                        }
                                        .product-cart-inner .media-body .amount-area {
                                            font-size: 14px;
                                            font-weight: 500;
                                            text-transform: uppercase;
                                        }
                                        .single-platform-inner.style-2 .details-inner .title {
                                            font-size: 20px;
                                            font-weight: 600;
                                        }
                                            .product-cart-inner .media-body .amount-area {
                                            font-size: 14px;
                                            font-weight: 500;
                                            text-transform: uppercase;
                                        }
                                            .single-platform-inner, .single-tournament-inner {
                                            position: relative;
                                            padding: 50px;
                                            margin-bottom: 30px;
                                        }
                                            
                                        .single-platform-inner.style-2 {
                                            padding: 40px;
                                        }
                                            a, a:active, a:focus, a:hover {
                                            text-decoration: none;
                                            outline: 0;
                                            color: inherit;
                                        }
                                        .widget-trending-match ul li .details .right-icon {
                                            position: absolute;
                                            right: 20px;
                                            top: 20px;
                                        }
                                        .widget-trending-match ul li .details span {
                                            font-size: 15px;
                                        }
                                        
                                        /* Mobile Table Styles */
                                        .table-responsive-wrapper {
                                            overflow-x: auto;
                                            -webkit-overflow-scrolling: touch;
                                        }
                                        
                                        .table-responsive {
                                            min-width: 100%;
                                        }
                                        
                                        @media (max-width: 768px) {
                                            .table-responsive-wrapper {
                                                border: 1px solid #303030;
                                                border-radius: 8px;
                                                padding: 10px;
                                                background: #161616;
                                            }
                                            
                                            #referal-leaderboard-data {
                                                font-size: 12px;
                                                min-width: 600px; /* Ensure minimum width for readability */
                                            }
                                            
                                            #referal-leaderboard-data th,
                                            #referal-leaderboard-data td {
                                                padding: 8px 4px;
                                                white-space: nowrap;
                                            }
                                        }
                                        
                                        @media (max-width: 480px) {
                                            #referal-leaderboard-data {
                                                font-size: 11px;
                                                min-width: 550px;
                                            }
                                            
                                            #referal-leaderboard-data th,
                                            #referal-leaderboard-data td {
                                                padding: 6px 3px;
                                            }
                                        }
                     `
                }
            </style>
        </>
    );
}
